<template>
  <el-dialog
      title="Новый абонемент"
      :visible="visible"
      :before-close="close"
      width="592px">

    <div v-loading="loading">
      <el-form
          :model="form"
          :rules="rules"
          label-position="top"
          ref="NewSubscriptionForm"
          @keyup.enter.native="sendForm"
          class="form">

        <el-form-item prop="title" label="Название абонемента">
          <el-input name="title" ref="title"
                    v-model="form.title"
                    placeholder="Название абонемента..."
                    auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item prop="department_id" label="Департамент">
          <el-select
              class="form__department"
              v-model="form.department_id"
              placeholder="Выберите департамент..."
              name="department_id"
              @change="changeDepartment"
          >
            <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
            ></el-option>
          </el-select>

        </el-form-item>

      </el-form>

      <el-alert
          v-if="!form.department_id"
          title="Пожалуйста, выберите департамент"
          type="info"
          :closable="false"
          class="tip"
          show-icon>
      </el-alert>
      <subscription-table
          v-else
          @update="sendForm"
          @updateServiceTypes="editServiceTypes"
          :newSubscription="true"
          :serviceTypes="serviceTypes"

          v-loading="loadingTypes"
          :user="user"/>



      <footer-buttons mt>
        <el-button type="primary"
                   @click="sendForm"
                   :disabled="loading">Сохранить
        </el-button>
      </footer-buttons>

    </div>

  </el-dialog>
</template>

<script>
// import {mapGetters} from "vuex"
import SubscriptionTable from "@/components/elements/UserSubscription/SubscriptionTable.vue"
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "NewSubscription",
  data() {
    return {
      serviceTypes: [],
      userMembershipProcedure: [],
      pagination: {},
      form: {},
      rules: {
        department_id: [{required: true, message: 'Укажите данные поля', trigger: 'blur'}],
        title: [{required: true, message: 'Введите данные в поле', trigger: 'blur'}]
      },
      departmentList: [],
      error: null,
      loading: false,
      loadingTypes: false,
    }
  },
  components: {
    SubscriptionTable,
    FooterButtons
  },
  props: {
    visible: {
      required: true,
    },
    user: {
      required: true,
    },

    subscription: {
      required: true,
    },

  },
  watch: {
    visible(value) {
      if (value) this.getDepartments()

    }
  },
  computed: {
    // ...mapGetters("session", {
    //       department: "department"
    //     }
    // ),
  },
  methods: {

    getDepartments() {
      this.loading = true

      this.$api.department.getList().then((response) => {
        this.departmentList = response.data
      }).catch(res => {
        this.$notify.error({
          title: "Ошибка загрузки списка центор",
          message: res.response.data.message,
        })

      }).finally(() => {

        this.loading = false
      })
    },
    changeDepartment() {
      this.loadServiceTypes()
    },
    loadServiceTypes() {
      this.loadingTypes = true

      this.$api.procedure.get(this.form.department_id).then((response) => {
        this.serviceTypes = response.data
      }).catch(res => {
        this.$notify.error({
          title: "Ошибка загрузки процедур",
          message: res.response.data.message,
        })
      }).finally(() => {
        this.loadingTypes = false
      })
    },
    close() {
      this.form = {}
      this.userMembershipProcedure = []
      this.$refs.NewSubscriptionForm.clearValidate()
      this.$emit('close')
    },
    editServiceTypes(data) {
      this.userMembershipProcedure = JSON.parse(JSON.stringify(data))
    },
    sendForm() {
      if (this.loading) return


      // this.error = null

      this.$refs.NewSubscriptionForm.validate((valid) => {
        if (valid) {

          if(!this.userMembershipProcedure.length) {
            this.$notify.error({
              title: "Ошибка  😕",
              message: 'Укажите хотя бы одну процедуру',
            })
            return
          }

          let payLoad = [...this.userMembershipProcedure]

          payLoad.splice(payLoad.length - 1, 1)
          payLoad = {...{user_membership_procedure: payLoad}, ...this.form}

          this.loading = true
          this.$api.membership.create(this.user.id, payLoad).then(() => {

            this.$notify.success({
              title: "Все хорошо",
              message: 'Данные отправлены',
            })

            this.close()
            this.$emit('update')

          }).catch(res => {
            this.$notify.error({
              title: "Ошибка сохранения",
              message: res.response.data.message,
            });

          }).finally(() => {
            this.loading = false
          })


        }
      })

    }
  }
}
</script>

<style scoped lang="scss">
.form {
  &__department {
    width: 100%;
  }
}

.dialog-footer {
  margin-top: 10px;
}
</style>
